
import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";

type FlavorObject = {
  description: string;
  ephemeral_gb: number;
  is_public: boolean;
  memory_mb: number;
  name: string;
  out_of_stock: boolean;
  preserve_id: true;
  region: string;
  root_gb: number;
  show_in_fleio: boolean;
  swap: number;
  use_for_dbaas: boolean;
  vcpus: number;
  flavor_id: null;
}

const flavorService = {
  getFlavors:(queries:QueriesApi) => ApiClient.get('openstack/flavors', {
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search
    }
  }),
  getCreateOptions:() => ApiClient.get('openstack/flavors/create_options'),
  createFlavor:(data:FlavorObject) => ApiClient.post('openstack/flavors', data),
  deleteFlavor:(id:string) => ApiClient.delete(`openstack/flavors/${id}`),
  updateFlavor:(id:string, data:any) => ApiClient.put(`openstack/flavors/${id}`, data),
  getFlavor:(id:string) => ApiClient.get(`openstack/flavors/${id}`),
  getFlavorById:(id:string) => ApiClient.get(`openstack/flavors/${id}`),




  getFlavorGroups:(queries:QueriesApi) => ApiClient.get('openstack/flavorgroups', {
    params:{
      page: queries.page,
      pageSize: queries.pageSize,
      ordering: queries.ordering,
      search: queries.search
    }
  }),
  getFlavorsInGroup:(id:string, queries:QueriesApi) => ApiClient.get(`openstack/flavors/get_flavors_in_group?page_size=${queries.pageSize}&ordering=${queries.ordering}&page=${queries.page}&group_id=${id}`),
  getFlavorGroup:(id:string) => ApiClient.get(`openstack/flavorgroups/${id}`),
  deleteFlavorGroup:(id:string) => ApiClient.delete(`openstack/flavorgroups/${id}`),
  createFlavorGroup:(data:any) => ApiClient.post('openstack/flavorgroups', data),
  editFlavorGroup:(data:any) => ApiClient.put(`openstack/flavorgroups/${data?.id}`, data),
  addFlavorToGroup:(id:string, data:any) => ApiClient.post(`openstack/flavors/${id}/add_to_group`, data),
  removeFlavorFromGroup:(id:string, data:any) => ApiClient.post(`openstack/flavors/${id}/remove_from_group`, data),
}

export default flavorService